<template>
  <PageWrapper
    :isLoading="isLoading"
    has-filters
    @submitFilters="getAllTermicCourses"
  >
    <template #title> کلاس های ترمیک </template>
    <template #titleBtn>
      <BButton variant="success" to="/termic-courses/create">
        افزودن کلاس ترمیک
      </BButton>
    </template>
    <template #filters>
      <SearchInput
        inputId="search"
        inputLabel="جستجوی کلاس های ترمیک"
        inputPlaceholder="مقدماتی"
        :inputValue="termicCourseFilters.search"
        v-model="termicCourseFilters.search"
        @enter="getAllTermicCourses"
      ></SearchInput>
    </template>
    <CustomTable
      v-if="termicCoursesList"
      ref="termicCoursesList"
      :pageNumber="termicCourseFilters.pageNumber"
      :count="termicCourseFilters.count"
      :totalCount="totalCount"
      :tableColumns="tableColumns"
      :tableItems="termicCoursesList"
      @changePage="changePage"
    >
      <template #termicCourseName="data">
        <span style="font-size: 14px">
          {{ data.item.termicCourseName }}

          ({{ data.item.language.persianTitle }})
        </span>
      </template>

      <template #days="data">
        <span
          v-for="(day, idx) in data.item.days"
          :key="day + 1 * data.index"
          style="font-size: 14px"
        >
          {{ weekDaysEnum[day] }}

          <template v-if="idx + 1 != data.item.days.length"> - </template>
        </span>
        <br />
        <span style="font-size: 14px; white-space: nowrap">
          {{
            new Date(data.item.startTime).toLocaleTimeString("fa-IR", {
              hour: "2-digit",
              minute: "2-digit",
            })
          }}
          -
          {{
            new Date(data.item.endTime).toLocaleTimeString("fa-IR", {
              hour: "2-digit",
              minute: "2-digit",
            })
          }}
        </span>
        <br />
        <span class="text-update" style="font-size: 12px; white-space: nowrap">
          ({{ data.item.sessions }} جلسه)
        </span>
      </template>

      <template #startDate="data">
        <span style="white-space: nowrap">
          {{ data.item.startDate ? new Date(data.item.startDate).toLocaleDateString("fa-IR") : "-" }}
        </span>
      </template>

      <template #masterUser="data">
        <b-link
          :to="`/users/${data.item.masterUser.masterUserId}`"
          style="font-size: 14px; white-space: nowrap"
        >
          {{ data.item.masterUser.fullName }}
        </b-link>
      </template>

      <template #termicCourseStatus="data">
        <BBadge
          class="font-weight-normal"
          :variant="termicCourseStatusChipColor[data.item.termicCourseStatus]"
          style="white-space: nowrap"
        >
          {{ termicCourseStatuses[data.item.termicCourseStatus] }}
        </BBadge>
      </template>

      <template #actions="data">
        <div class="d-flex align-items-center">
          <button
            @click="renderStartTermicCourseConfirmationDialog(data.item)"
            :disabled="isStartCourseButtonDisabled(data.item)"
            type="button"
            class="btn p-0 m-0 mr-1"
            v-b-tooltip="'شروع کلاس'"
          >
            <FeatherIcon icon="PlayCircleIcon" class="text-success" size="20" />
          </button>

          <button
            @click="renderUpdateTermicCourseConfirmationDialog(data.item)"
            :disabled="data.item.termicCourseStatus != 1"
            type="button"
            class="btn p-0 m-0 mr-1"
            v-b-tooltip="'تغییر وضعیت به در حال ثبت نام'"
          >
            <FeatherIcon icon="RefreshCwIcon" class="text-update" size="20" />
          </button>

          <button
            @click="renderFinishTermicCourseConfirmationDialog(data.item)"
            :disabled="data.item.termicCourseStatus != 6"
            type="button"
            class="btn p-0 m-0 mr-1"
            v-b-tooltip="'اتمام کلاس ترمیک'"
          >
            <FeatherIcon icon="StopCircleIcon" class="text-warning" size="20" />
          </button>

          <button
            @click="renderCancelTermicCourseConfirmationDialog(data.item)"
            :disabled="
              data.item.termicCourseStatus == 4 ||
              data.item.termicCourseStatus == 5
            "
            type="button"
            class="btn p-0 m-0 mr-1"
            v-b-tooltip="'کنسل کردن کلاس ترمیک'"
          >
            <FeatherIcon icon="SlashIcon" class="text-danger" size="20" />
          </button>

          <b-link
            class="btn p-0 m-0"
            :to="`/termic-courses/${data.item.id}`"
            v-b-tooltip="'مشاهده جزئیات'"
          >
            <feather-icon
              icon="ExternalLinkIcon"
              class="text-primary"
              size="20"
            />
          </b-link>
        </div>
      </template>
    </CustomTable>
    <UpdateTermicCourseStatusConfirmationDialog
      @refetch="getAllTermicCourses"
      :termicCourseDetails="tempSelectedTermicCourse"
    ></UpdateTermicCourseStatusConfirmationDialog>
    <StartTermicCourseConfirmationDialog
      @refetch="getAllTermicCourses"
      :termicCourseDetails="tempSelectedTermicCourse"
    ></StartTermicCourseConfirmationDialog>
    <CancelTermicCourseConfirmationDialog
      @refetch="getAllTermicCourses"
      :termicCourseDetails="tempSelectedTermicCourse"
    ></CancelTermicCourseConfirmationDialog>
    <FinishTermicCourseConfirmationDialog
      @refetch="getAllTermicCourses"
      :termicCourseDetails="tempSelectedTermicCourse"
    ></FinishTermicCourseConfirmationDialog>
  </PageWrapper>
</template>

<script>
export default {
  mounted() {
    this.getAllTermicCourses();
  },
  data() {
    return {
      isLoading: false,
      termicCourseFilters: {
        pageNumber: 1,
        count: 10,
        search: null,
      },
      weekDaysEnum: {
        0: "یکشنبه",
        1: "دوشنبه",
        2: "سه‌شنبه",
        3: "چهارشنبه",
        4: "پنجشنبه",
        5: "جمعه",
        6: "شنبه",
      },
      tableColumns: [
        {
          key: "termicCourseName",
          label: "نام کلاس",
        },
        {
          key: "days",
          label: "روز های برگذاری",
        },
        {
          key: "startDate",
          label: "تاریخ شروع",
        },
        {
          key: "masterUser",
          label: "استاد",
        },
        {
          key: "price",
          label: "قیمت",
          formatter: (val) => `${Intl.NumberFormat("en-US").format(val)} تومان`,
        },
        {
          key: "masterIncome",
          label: "درآمد استاد",
          formatter: (val) => `${Intl.NumberFormat("en-US").format(val)} تومان`,
        },
        {
          key: "termicCourseStatus",
          label: "وضعیت کلاس",
        },
        // {
        //   key: "termicCourseStatus",
        //   label: "وضعیت کلاس",
        // },
        {
          key: "actions",
          label: "عملیات",
        },
      ],
      termicCoursesList: null,
      totalCount: null,
      termicCourseStatuses: {
        0: "ثبت اولیه",
        1: "در انتظار تایید",
        2: "در حال ثبت نام",
        3: "تکمیل ظرفیت",
        4: "کنسل شده",
        5: "به اتمام رسیده",
        6: "در حال برگزاری",
      },
      termicCourseStatusChipColor: {
        0: "secondary", // Gray
        1: "warning", // Orange
        2: "update", // Blue
        3: "update", // Blue
        4: "danger", // Red
        5: "info", // Cyan
        6: "success", // Green
      },
      tempSelectedTermicCourse: null,
    };
  },
  methods: {
    renderStartTermicCourseConfirmationDialog(selectedTermicCourse) {
      this.tempSelectedTermicCourse = selectedTermicCourse;
      this.$bvModal.show("start-termic-course-confirmation-dialog");
    },
    renderCancelTermicCourseConfirmationDialog(selectedTermicCourse) {
      this.tempSelectedTermicCourse = selectedTermicCourse;
      this.$bvModal.show("cancel-termic-course-confirmation-dialog");
    },
    renderFinishTermicCourseConfirmationDialog(selectedTermicCourse) {
      this.tempSelectedTermicCourse = selectedTermicCourse;
      this.$bvModal.show("finish-termic-courses-status-dialog");
    },
    isStartCourseButtonDisabled(courseDetails) {
      const status = courseDetails.termicCourseStatus;
      if (status == 2 || status == 3) {
        return false;
      }
      return true;
    },
    async getAllTermicCourses() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllTermicCourses = new GetAllTermicCourses(_this);
        getAllTermicCourses.setRequestParam(_this.termicCourseFilters);
        await getAllTermicCourses.fetch((res) => {
          _this.termicCoursesList = res.data.data;
          _this.totalCount = res.data.total;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    renderUpdateTermicCourseConfirmationDialog(selectedTermicCourse) {
      this.tempSelectedTermicCourse = selectedTermicCourse;
      this.$bvModal.show("update-termic-courses-status-dialog");
    },
    formatStartEndDate(date) {
      return `${new Date(date).toLocaleDateString("fa-IR", {
        day: "2-digit",
      })} ${new Date(date).toLocaleDateString("fa-IR", {
        month: "long",
      })} ${new Date(date).toLocaleDateString("fa-IR", {
        year: "numeric",
      })}`;
    },
    changePage(pageNumber) {
      this.termicCourseFilters.pageNumber = pageNumber;
      this.getAllTermicCourses();
    },
  },
  directives: {
    BTooltip: VBTooltip,
  },
  components: {
    PageWrapper,
    CustomTable,
    SearchInput,
    UpdateTermicCourseStatusConfirmationDialog,
    StartTermicCourseConfirmationDialog,
    CancelTermicCourseConfirmationDialog,
    FinishTermicCourseConfirmationDialog,
    BButton,
    BLink,
    BBadge,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import SearchInput from "@/views/components/Utils/SearchInput.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import UpdateTermicCourseStatusConfirmationDialog from "@/views/components/TermicCourses/UpdateTermicCourseStatusConfirmationDialog.vue";
import StartTermicCourseConfirmationDialog from "@/views/components/TermicCourses/StartTermicCourseConfirmationDialog.vue";
import CancelTermicCourseConfirmationDialog from "@/views/components/TermicCourses/CancelTermicCourseConfirmationDialog.vue";
import FinishTermicCourseConfirmationDialog from "@/views/components/TermicCourses/FinishTermicCourseConfirmationDialog.vue";
import { BButton, BLink, VBTooltip, BBadge } from "bootstrap-vue";
import { GetAllTermicCourses } from "@/libs/Api/TermicCourses";
</script>
